import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0 ${layout.measurements.spacingSmall} 0;
  margin-bottom: ${layout.measurements.spacingTiny};
`;
